import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import Checkbox from '@blocks/Input/Checkbox'
import React from 'react'

export default function PromocodeForm({ model: promocode }: Modules.Resource.Form<Interfaces.Promo.Includes<"payments">>) {
    return (
        <Grid columns="3">
            <Input id="code" name="code" label="Code" placeholder="discount30" defaultValue={promocode?.code} required />
            <Input id="discount" name="discount" type="number" label="Discount" placeholder="30 (%)" defaultValue={promocode?.discount} required />
            <Input id="until" name="until" type="date" label="End date" placeholder="MM/DD/YYYY" defaultValue={promocode?.until} required />
            <Checkbox id="is_early_bird" name="is_early_bird" label="Early Bird" checked={promocode?.is_early_bird || undefined} />
        </Grid>
    )
}